<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('materiel.tlpe.title') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <div class="columns">
          <div class="column" :class="[{'is-11': materiel.typeTaxationTlpeId},
          { 'is-12': !materiel.typeTaxationTlpeId }]">
            <b-field :label="$t('materiel.tlpe.typeTaxation')"
                   :type="typeTaxationTlpeFieldType"
                   :message="typeTaxationTlpeFieldMessage"
            >
              <b-autocomplete :open-on-focus="false"
                              :data="typeTaxeTlpeList"
                              :value="libelle"
                              field="libelle"
                              :placeholder="$i18n.t('materiel.tlpe.actions.ajouterTaxe')"
                              @input="getTypeTaxation"
                              icon="magnify"
                              :loading="isFetching"
                              @select="setInformationTlpe">
                <template slot="empty">
                  <div v-if="!isFetching">
                    {{$t('materiel.tlpe.actions.noResult')}}
                  </div>
                  <div v-else>
                    {{$t('materiel.tlpe.actions.searchEnCours')}}
                  </div>
                </template>
              </b-autocomplete>
            </b-field>
          </div>
          <div class="column is-1 pdl-0"
               v-if="materiel.typeTaxationTlpeId"
               @click="popUpInformationTarif = !popUpInformationTarif">
            <div class="pdt-5px mgt-30px">
            <b-icon type="is-primary" icon="information" custom-size="mdi-24px"
                    class="is-cursor-pointer">
            </b-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <b-field :label="$t('materiel.tlpe.surfaceTlpe')" custom-class="ellipsis">
          <qd-numberinput v-model="getSurfaceTlpe"
                         disabled
                         :controls="false" step="0.01">
          </qd-numberinput>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('materiel.tlpe.surfaceTlpePerso')" custom-class="ellipsis">
          <b-input v-model="materiel.surface.surfaceTlpe" step="0.01"
                         type="number">
          </b-input>
        </b-field>
      </div>
    </div>
    <b-modal v-model="popUpInformationTarif" width="900px" has-modal-card class="modal"
             v-if="popUpInformationTarif">
      <informationTarifsTlpe
        :typeTaxationTlpeId="materiel.typeTaxationTlpeId"
        :surfaceTlpe="materiel.surface.surfaceTlpe !== null
        ? materiel.surface.surfaceTlpe : getSurfaceTlpe"
        :surfaceCommerciale="materiel.surface.surfaceCommerciale !== null
        ? materiel.surface.surfaceCommerciale : getSurfaceCommerciale">
      </informationTarifsTlpe>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import informationTarifsTlpe from '@/components/gabed/materiel/p_informationTarifsTlpe';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllTypeTaxationTlpe } from '@/api/typeTaxationTlpe';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'MaterielEditTLPE',
  props: {
    materiel: {
      type: Object,
      reuired: true,
    },
  },
  data() {
    return {
      isFetching: false,
      typeTaxeTlpeList: [],
      libelle: null,
      popUpInformationTarif: false,
      typeTaxationTlpe: [],
    };
  },
  components: {
    informationTarifsTlpe,
  },
  methods: {
    setInformationTlpe(data) {
      if (data) {
        this.libelle = data.libelle;
        this.materiel.typeTaxationTlpe = cloneDeep(data);
        this.materiel.typeTaxationTlpeId = cloneDeep(data.id);
      }
    },
    getTypeTaxation: debounce(async function tlpeTaxationData(text) {
      if (!text) {
        this.materiel.typeTaxationTlpe = null;
        this.materiel.typeTaxationTlpeId = null;
        return;
      }
      if (this.libelle === text) return;
      try {
        this.libelle = text;
        this.materiel.typeTaxationTlpeId = null;
        this.isFetching = true;
        this.typeTaxeTlpeList = (await getAllTypeTaxationTlpe({
          query: { societeId: this.societeActiveId, auto: text, actif: true },
          limit: NO_PAGINATION,
        })).data.result.items;
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    materielFormat() {
      return this.parametre(PARAMETRES_KEYS.materielFormat);
    },
    getSurfaceTlpe() {
      const formatFind = this.materielFormat.find((materielFormat) => {
        return materielFormat.id === this.materiel.formatId;
      });
      return formatFind ? formatFind.surface.surfaceTlpe : null;
    },
    getSurfaceCommerciale() {
      const formatFind = this.materielFormat.find((materielFormat) => {
        return materielFormat.id === this.materiel.formatId;
      });
      return formatFind ? formatFind.surface.surfaceCommerciale : null;
    },
    isTypeTaxationTlpeActif() {
      return this.materiel.typeTaxationTlpe ? this.materiel.typeTaxationTlpe.actif : true;
    },
    typeTaxationTlpeFieldType() {
      return !this.isTypeTaxationTlpeActif ? 'is-warning' : '';
    },
    typeTaxationTlpeFieldMessage() {
      return !this.isTypeTaxationTlpeActif
        ? this.$t('detailMateriel.warning.archivedTypeTaxationTlpeSelectedAbove') : '';
    },
  },
  mounted() {
    this.libelle = this.materiel.typeTaxationTlpe ? this.materiel.typeTaxationTlpe.libelle : '';
  },
};
</script>
